import { SET_LOGIN_MODAL, SET_RATING_MODAL } from "../types/types";

export const setLoginModal = (value) => {
  return {
    type: SET_LOGIN_MODAL,
    payload: { data: value },
  };
};
export const setRatingModal = (value) => {
  return {
    type: SET_RATING_MODAL,
    payload: { data: value },
  };
};
export const setQuestionnaireModalOpen = (value) => {
  return {
    type: "SET_QUESTIONNAIRE_MODAL",
    payload: { data: value },
  };
};
